export default "__VITE_ASSET__CRmGD1p0__"